import { first, map } from 'rxjs/operators';
import { Observable } from 'rxjs';

export const withSelector = <S, T>(state$: Observable<S>, selector: (state: S) => T): Observable<T> => (
    state$.pipe(
        first(),
        map(selector),
    )
);
